import { styled } from '@mui/material/styles';
import { Paper } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

export const StyledPaper = styled(Paper)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2)
}));

export const StyledCircleIcon = styled(CircleIcon)({
  fontSize: '12px'
}); 